/**
* Created By: Emilio Blanco
* Creation Date: 03/10/2022
* PBI: 78282 - Landing Bienvenida Cotizador Bepensa
*
* Last Modifier:
* Last Modification: 
*
* Feat: 
*
* version: 1.0.0
* copyright: 2022 INDUSTRIAS RESSER S.A DE C.V
*/
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataResponse } from '../../../interfaces/commonInterfaces';

export const initialState: DataResponse = {
    CreditObjProduct: [],
    CreditObjPlazo: [
      {
        Fib_ConfiguradorCotizadorId: "",
        Fib_Name: "",
        Fib_TipoPersona: "",
        Fib_EsArrendamiento: "",
        Fib_Segmento: "",
        Fib_IVA: "",
        Fib_ComisionApertura: "",
        Fib_VAU_Arrenda: "",
        Fib_ISR_Arrenda: "",
        Fib_PTU_Arrenda: "",
        details: {
          Fib_PlanContizadorDetalleId: "",
          Fib_ConfiguradorCotizadorId: "",
          Fib_Antiguedad: "",
          Fib_Enganche: "",
          Fib_Tasa: "",
          Fib_Plazo: "",
          Fib_VAU_Arrenda: "",
          terms: [],
          rates: [],
          vauRates: [],
          openingComission: [],
        },
      },
    ],
    ObjActividad: [],
    CreditResultCotizacion: [
      {
        calculus_name: "",
        calculus_code: "",
        credit_total: 0,
        downpayment_deposit: 0,
        amount_to_finance: 0,
        total_payment: null,
        credit_start_date: "",
        grace_period_start_date: "",
        credit_length_in_months: 0,
        rate: 0,
        grace_periods: 0,
        administration_cost: 0,
        terms: {
          term: 0,
          payment_date: "",
          capital: 0,
          payment: null,
          interest: null,
          interest_iva: null,
          initial_balance: 0,
          final_balance: 0,
          daysYearAveragePerMonth: null,
          administration_cost: 0,
          administration_cost_iva: 0,
        },
      },
    ],
    ObjActivo: [],
    filteredObjActivo : [],
    LeasingObjPlazo: [],
    LeasingRentMargin: undefined,
    UserId: undefined,
    ObjCanalArrendamiento: [],
    LeasingResultCotizacion: {
        rent: 0,
        pagoInicial: 0,
        montoFinanciado: 0,
        valorEquipo: 0,
        seguroPrimerAno: 0,
        comisionApertura: 0,
        Anticipo: 0,
        AdvanceRent:0,
        AdvanceCommision:0
    },
  };


  
  export const DataResponseSlice = createSlice({
    name: 'CreditDataResponse',
    initialState,
    reducers: {
      setCreditObjProduct: (state, action: PayloadAction<{ id: number; name: string }[]>) => {
        state.CreditObjProduct = action.payload;
      },
      setObjActividad: (state, action: PayloadAction<{ id: number; name: string }[]>) => {
        state.ObjActividad = action.payload;
      },
      setCreditObjPlazo: (state, action: PayloadAction<CreditObjPlazo>) => {
        state.CreditObjPlazo = action.payload;
      },
      setCreditResultadoCotizacion: (state, action: PayloadAction<CreditResultCotizacion>) => {
        state.CreditResultCotizacion = action.payload;
      },
      setUserID: (state, action: PayloadAction<number>) => {
        state.UserId = action.payload;
      },
      setObjActivo: (state: DataResponse, action: PayloadAction<{ id: number, name: string }[]>) => { 
        state.ObjActivo = action.payload 
      },
      setFilteredObjActivo: (state: DataResponse, action: PayloadAction<{ id: number, name: string, IsForPyme: boolean }[]>) => { 
        state.filteredObjActivo = action.payload 
      },
      setLeasingObjPlazo: (state: DataResponse, action: PayloadAction<{ id: number, name: string }[]>) => { 
        state.LeasingObjPlazo = action.payload 
      },
      setLeasingResultCotizacion: (state, action: PayloadAction<LeasingResultCotizacion>) => {
        state.LeasingResultCotizacion = action.payload;
      },
      setLeasingRentMargin: (state, action: PayloadAction<number>) => {
        state.LeasingRentMargin = action.payload;
      },
      setObjCanalArrendamiento: (state: DataResponse, action: PayloadAction<{ AnticipoMinimo: number, PlazoMeses: number, ResidualEstandar: number, ResidualMaximo: number, ResidualMinimo: number, _: number }[]>) => { 
        state.ObjCanalArrendamiento = action.payload 
      },
    },
  });

  export type CreditObjPlazo = {
    Fib_ConfiguradorCotizadorId: string;
    Fib_Name: string;
    Fib_TipoPersona: string;
    Fib_EsArrendamiento: string;
    Fib_Segmento: string;
    Fib_IVA: string;
    Fib_ComisionApertura: string;
    Fib_VAU_Arrenda: string;
    Fib_ISR_Arrenda: string;
    Fib_PTU_Arrenda: string;
    details: {
      Fib_PlanContizadorDetalleId: string;
      Fib_ConfiguradorCotizadorId: string;
      Fib_Antiguedad: string;
      Fib_Enganche: string;
      Fib_Tasa: string;
      Fib_Plazo: string;
      Fib_VAU_Arrenda: string;
      terms: Array<number>,
      rates: Array<string>,
      vauRates: Array<number>,
      openingComission: Array<number>,
    };
  }[];
export type CreditResultCotizacion = {
    calculus_name: string,
    calculus_code: string,
    credit_total: number,
    downpayment_deposit: number,
    amount_to_finance: number,
    total_payment: number | null,
    credit_start_date: string,
    grace_period_start_date: string,
    credit_length_in_months: number,
    rate: number,
    grace_periods: number,
    administration_cost: number,
    terms: {
      term: number,
      payment_date: string,
      capital: number,
      payment: number | null,
      interest: number | null,
      interest_iva: number | null,
      initial_balance: number,
      final_balance: number,
      daysYearAveragePerMonth: number | null,
      administration_cost: number,
      administration_cost_iva: number,
    }
  }[];
export type LeasingResultCotizacion = {
  rent: number | undefined,
  pagoInicial: number | undefined,
  montoFinanciado: number | undefined,
  valorEquipo: number | undefined,
  seguroPrimerAno: number | undefined,
  comisionApertura: number | undefined,
  Anticipo: number | undefined,
  AdvanceRent: number | undefined,
  AdvanceCommision: number | undefined,
};

export type CanalArrendamiento = {
  AnticipoMinimo: number,
  PlazoMeses: number,
  ResidualEstandar: number,
  ResidualMaximo: number,
  ResidualMinimo: number,
  _: number
}

  export const {
    setCreditObjPlazo,
    setCreditObjProduct,
    setCreditResultadoCotizacion,
    setObjActividad,
    setUserID,
    setObjActivo,
    setFilteredObjActivo,
    setLeasingObjPlazo,
    setObjCanalArrendamiento,
    setLeasingResultCotizacion,
    setLeasingRentMargin,
  } = DataResponseSlice.actions;
  
  export default DataResponseSlice.reducer;
